
import React from 'react';

interface CTASectionProps {
  onShowContactForm: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onShowContactForm }) => {
  return (
    <section className="section bg-brand-lightBlue/30 relative">
      <div className="absolute inset-0 opacity-5">
        <img 
          src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf" 
          alt="Business meeting" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="container relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-4 text-gray-900">
            Wil je een persoonlijk adviesgesprek?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Laat je gegevens achter en we bellen je binnen 24 uur voor een vrijblijvend gesprek over jouw mogelijkheden.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onShowContactForm} 
              className="btn-primary flex items-center justify-center gap-2"
            >
              Ontvang een persoonlijk advies
            </button>
            <a href="/leadgeneratie-kmo" className="btn-outline">Meer over onze aanpak</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
